/** Merge under presentationAuthoring.narrationControls for each locale. */
export const narrationFeedbackCopy = {
  en: {
    voiceLoadError: 'Voices could not be loaded',
    noVoices:
      'No voices are available. A company Owner or Admin needs to connect Gemini in AI Providers & Voice before narration can be generated.',
    scriptUnsaved:
      'The latest script is still being saved. Generate is available once it is saved.',
  },
  fa: {
    voiceLoadError: 'بارگذاری صداها ناموفق بود',
    noVoices:
      'صدایی در دسترس نیست. مالک شرکت باید Gemini را در بخش «ارائه‌دهندگان هوش مصنوعی و صدا» متصل کند تا روایت تولید شود.',
    scriptUnsaved: 'آخرین متن هنوز در حال ذخیره است. پس از ذخیره‌شدن می‌توانید صوت را تولید کنید.',
  },
} as const;
